import { useState } from "react";
import { Copy, Check } from "lucide-react";

export default function CopyAddress({ address, testid }) {
  const [done, setDone] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(address).catch(() => {});
    setDone(true);
    setTimeout(() => setDone(false), 1500);
  };
  return (
    <div className="mt-3 flex items-center gap-2 rounded-md border border-[#2E3C54] bg-[#080B10] p-2.5">
      <code data-testid={testid} className="min-w-0 flex-1 break-all font-mono text-xs text-slate-100">{address}</code>
      <button onClick={copy} data-testid={`${testid}-copy`} className="rounded p-1.5 text-slate-400 transition-colors hover:bg-[#161D2A] hover:text-white">
        {done ? <Check className="h-4 w-4 text-[#00E676]" /> : <Copy className="h-4 w-4" />}
      </button>
    </div>
  );
}
